export default {
  searchDate: (state) => {
    return state.searchDate;
  },
  mediaTypes: (state) => {
    return state.mediaTypes;
  },
};
